import { Component } from '@angular/core';
import {
  formBuilder,
  input,
  select,
} from '@kinet-open-network/client/core/forms/ui';
import { AutomationTrigger } from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';
import {
  TRIGGER_DATA_TEMPLATE,
  TriggerComponent,
} from './abstract-trigger.component';

@Component({
  selector: 'kon-cron-trigger',
  imports: [FormlyModule],
  template: TRIGGER_DATA_TEMPLATE,
})
export class CronTriggerComponent extends TriggerComponent<AutomationTrigger.Cron> {
  override fields = formBuilder([
    input('expression', 'Cron výraz')
      .required()
      .description(
        'Zadajte CRON výraz pre spúšťanie automatizácie. Napr. "0 0 * * *" pre spúšťanie každý deň o polnoci.',
      ),

    select('timezone', 'Časová zóna').options(
      Intl.supportedValuesOf('timeZone').map((tz) => ({
        label: tz,
        value: tz,
      })),
    ),
  ]);
}
